export function joinPaymentMethodValues({
  orderPaymentSummary,
  orderReturnPaymentSummary,
  name,
  method,
  methodReturn,
}) {
  const payment = getValuesOfMethodFromPayments(
    orderPaymentSummary,
    method,
    name
  );

  const returnMoney = getValuesOfMethodFromPayments(
    orderReturnPaymentSummary,
    method,
    name,
    methodReturn
  );

  payment.code = method;
  payment.sells = payment.money;
  payment.returns = returnMoney.returns;
  payment.operationsPlus = payment.operations;
  payment.operationsMinus = returnMoney.operations;
  payment.earnings =
    parseFloat(payment.sells) - parseFloat(returnMoney.returnsTotal);

  return payment;
}

function getValuesOfMethodFromPayments(
  paymentMethods,
  method,
  name,
  methodReturn
) {
  const paymentMethod = paymentMethods.find((o) => o._id.code === method);

  const value = {
    name,
    money: 0,
    operations: 0,
    returns: 0,
    returnsTotal: 0,
  };

  const returnMoney = paymentMethods.find((o) => {
    return o._id.code === methodReturn
  });

  

  if (returnMoney) {
    value.returns = returnMoney?.count;
    value.returnsTotal = returnMoney?.total;
  }

  if (paymentMethod) {
    value.money = paymentMethod.total;
    value.operations = paymentMethod?.count;
  }

  return value;
}
